import React from 'react';
import { DateRow, StatusCard, TextToolTip } from 'components';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { FindLoad, renderFirstLetters, renderStaffName, User } from 'utils';

const ACTION_TYPE = 'GET_MY_PROFILE';
export const YourProfileDashboard = ({ handleDeleteWidget }) => {
    const { userInfo } = User();
    const loader = FindLoad(ACTION_TYPE);

    const handleViewProfile = () => {
        window.open(`/staff/${userInfo?.id}`, '_blank', 'noopener,noreferrer');
    };

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell
            iconId={6}
            onClose={handleDeleteWidget}
            onOpen={userInfo?.id ? handleViewProfile : undefined}
        >
            <div className="main-dashboard-card-body">
                <div className="your-profile-dashboard-wrapper">
                    <div className="your-profile-dashboard-block">
                        <div className="your-profile-dashboard-image-name-block">
                            <div className="your-profile-dashboard-image-block">
                                {userInfo?.avatar?.url ?
                                    <img src={userInfo?.avatar?.url} alt="avatar" /> : renderFirstLetters(userInfo)}
                            </div>

                            <div className="your-profile-dashboard-name-email">
                                <TextToolTip
                                    text={`${userInfo?.firstName} ${userInfo?.lastName ? userInfo.lastName : ''}`}
                                    content={`${userInfo?.firstName} ${userInfo?.lastName ? userInfo.lastName : ''}`}
                                    classNameText='your-profile-dashboard-name'
                                />
                                <p className="your-profile-dashboard-email">{userInfo?.email ? userInfo?.email : '--'}</p>
                            </div>
                        </div>

                        <StatusCard status={userInfo?.status} />
                    </div>
                    <div className='your-profile-dashboard-info-wrapper' style={{flexWrap: 'nowrap'}}>
                        <div className="your-profile-dashboard-info-wrapper">
                            <div className="your-profile-dashboard-info-block">
                                <div className="your-profile-dashboard-info-title">Supervisor</div>

                                <div className="your-profile-dashboard-info-description">
                                    {renderStaffName(userInfo?.employment?.supervisor)}
                                </div>
                            </div>


                            <div className="your-profile-dashboard-info-block">
                                <div className="your-profile-dashboard-info-title">Start Date</div>

                                <div className="your-profile-dashboard-info-description">
                                    <DateRow date={userInfo?.hiredDate} />
                                </div>
                            </div>
                        </div>

                        <div className="your-profile-dashboard-info-wrapper">
                            <div className="your-profile-dashboard-info-block">
                                <div className="your-profile-dashboard-info-title">Role</div>

                                <div
                                    className="your-profile-dashboard-info-description">{userInfo?.employment?.title?.name || '--'}</div>
                            </div>

                            <div className="your-profile-dashboard-info-block">
                                <div className="your-profile-dashboard-info-title">Phone</div>

                                <div className="your-profile-dashboard-info-description">
                                    <TextToolTip
                                        classNameText="your-profile-dashboard-info-description"
                                        text={userInfo?.phone}
                                        content={userInfo?.phone}
                                        phoneRow
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </DashboardWidgetShell>
    );
};
